import Vue from 'vue'
// @ts-expect-error checked
import Vuetify from 'vuetify/lib/framework'
// @ts-expect-error checked
import pl from 'vuetify/es5/locale/pl'

Vue.use(Vuetify)

// @ts-expect-error checked
const template = import.meta.env.VITE_APP === 'gd'
  ? {
      light: {
        primary: '#407595',
        secondary: '#407595',
        accent: '#407595',
        darkBlue: '#407595',
        background: '#FFF',
        neutral: '#000000',
        surface: '#F2F2F2',
      },
      dark: {
        primary: '#407595',
        secondary: '#407595',
        accent: '#407595',
        darkBlue: '#407595',
        background: '#121212',
        neutral: '#ffffff',
        surface: '#232323',
      },
    }
  : {
      light: {
        primary: '#5e03a8',
        secondary: '#5f56ff',
        // accent: '#407595',
        // darkBlue: '#407595',
        // background: '#FFF',
        // neutral: '#000000',
        // surface: '#F2F2F2',
      },
      dark: {
        primary: '#b356ff',
        secondary: '#5f56ff',
        // accent: '#407595',
        // darkBlue: '#407595',
        // background: '#121212',
        // neutral: '#ffffff',
        // surface: '#232323',
      },
    }

const mq = window.matchMedia('(prefers-color-scheme: dark)')
const dark

  = localStorage.dark === undefined
    ? mq.matches
    : JSON.parse(localStorage.dark)

const vuetify = new Vuetify({
  lang: {
    locales: { pl },
    current: 'pl',
  },
  theme: {
    dark,
    themes: template,
    options: {
      variations: false,
      minifyTheme(css: string) {
        // @ts-expect-error checked
        return import.meta.env.NODE_ENV === 'production'
          ? css.replace(
              /[\r\n|]/g,
              '',
            )
          : css
      },
    },
  },
  icons: {
    iconfont: 'mdiSvg',
  },
})

vuetify.framework.theme.dark

  = localStorage.dark === undefined
    ? mq.matches
    : JSON.parse(localStorage.dark)
mq.addListener((event) => {
  vuetify.framework.theme.dark

    = localStorage.dark === undefined
      ? event.matches
      : JSON.parse(localStorage.dark)
})

export default vuetify
